import { Button } from "@gisce/oficina-virtual-components"
import {
  SpaceDashboard
} from "@mui/icons-material";
import DinamicServerNavigation from "@/components/ServerElements/components/DinamicServerNavigation";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const UpLg = () => {
  const Settings = useSettingsContext();

return <>
  {Settings?.header?.variant === "horizontal" && <>

    {Settings.features?.enableServerElements &&
      <DinamicServerNavigation
        clickableComponent={({ children, onClick }) => {
          return (
            <Button
              variant="contained"
              startIcon={<SpaceDashboard />}
              onClick={onClick}
            >
              {children}
            </Button>
          )
        }}
      />
    }
  </>}
</>
}